import React from "react";
import { ChartDataResponse } from "../ceo-dashboard.service";

interface DashboardCardsProps {
  chartData: ChartDataResponse | null;
  loading: boolean;
}

const DashboardCards: React.FC<DashboardCardsProps> = ({
  chartData,
  loading,
}) => {
  // Calculate totals from the chart data
  const calculateTotalByType = (type: string) => {
    if (!chartData?.data) return 0;
    return chartData.data
      .filter((item) => item.trx_type === type)
      .reduce((sum, item) => sum + parseFloat(item.amount_kwd), 0);
  };

  const totalDeposit = calculateTotalByType("Deposit");
  const totalWithdrawal = calculateTotalByType("Withdrawal");
  const totalSubscription = calculateTotalByType("Subscription");
  const totalRedemption = calculateTotalByType("Redemption");

  return (
    <div className="w-full lg:w-[30rem] inline-flex flex-col justify-start items-start gap-5 lg:h-[420px]">
      <div className="self-stretch grid grid-cols-1 sm:grid-cols-2 gap-5 flex-1">
        <div className="flex-1 p-4 bg-white rounded-lg inline-flex flex-col justify-between items-start shadow-md h-full min-h-[160px]">
          <div className="self-stretch inline-flex justify-between items-start">
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-3.5 min-w-0">
              <div className="self-stretch opacity-70 justify-start text-neutral-800 text-xs font-semibold ">
                Total Deposit
              </div>
              <div className="self-stretch justify-start flex items-baseline gap-1">
                <span className="text-zinc-800 font-bold text-[1rem] ">
                  {loading ? "Loading..." : totalDeposit.toLocaleString()}
                </span>
                <span className="text-zinc-800 font-semibold">KWD</span>
              </div>
            </div>
            <img src="/images/total-deposit.svg" alt="Deposit" />
          </div>
          <div className="self-stretch mt-2 pt-2 border-t border-gray-100">
            <div className="text-zinc-500 text-xs">
              {loading ? "" : "Cash inflows from customer deposits"}
            </div>
          </div>
        </div>
        <div className="flex-1 p-4 bg-white rounded-lg inline-flex flex-col justify-between items-start shadow-md h-full min-h-[160px]">
          <div className="self-stretch inline-flex justify-between items-start">
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-4 min-w-0">
              <div className="self-stretch opacity-70 justify-start text-neutral-800 text-xs font-semibold ">
                Total Withdrawal
              </div>
              <div className="self-stretch justify-start flex items-baseline gap-1">
                <span className="text-zinc-800 font-bold text-[1rem] ">
                  {loading ? "Loading..." : totalWithdrawal.toLocaleString()}
                </span>
                <span className="text-zinc-800 font-semibold">KWD</span>
              </div>
            </div>
            <img src="/images/total-withdraw.svg" alt="Withdrawal" />
          </div>
          <div className="self-stretch mt-2 pt-2 border-t border-gray-100">
            <div className="text-zinc-500 text-xs">
              {loading ? "" : "Cash outflows from customer withdrawals"}
            </div>
          </div>
        </div>
      </div>
      <div className="self-stretch grid grid-cols-1 sm:grid-cols-2 gap-5 flex-1">
        <div className="flex-1 p-4 bg-white rounded-lg inline-flex flex-col justify-between items-start shadow-md h-full min-h-[160px]">
          <div className="self-stretch inline-flex justify-between items-start">
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-4 min-w-0">
              <div className="self-stretch opacity-70 justify-start text-neutral-800 text-xs font-semibold ">
                Total Subscription
              </div>
              <div className="self-stretch justify-start flex items-baseline gap-1">
                <span className="text-zinc-800 font-bold text-[1rem] ">
                  {loading ? "Loading..." : totalSubscription.toLocaleString()}
                </span>
                <span className="text-zinc-800 font-semibold">KWD</span>
              </div>
            </div>
            <img src="/images/total-subscription.svg" alt="Subscription" />
          </div>
          <div className="self-stretch mt-2 pt-2 border-t border-gray-100">
            <div className="text-zinc-500 text-xs">
              {loading ? "" : "Investment fund subscriptions"}
            </div>
          </div>
        </div>
        <div className="flex-1 p-4 bg-white rounded-lg inline-flex flex-col justify-between items-start shadow-md h-full min-h-[160px]">
          <div className="self-stretch inline-flex justify-between items-start">
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-4 min-w-0">
              <div className="self-stretch opacity-70 justify-start text-neutral-800 text-xs font-semibold ">
                Total redemption
              </div>
              <div className="self-stretch justify-start flex items-baseline gap-1">
                <span className="text-zinc-800 font-bold text-[1rem] ">
                  {loading ? "Loading..." : totalRedemption.toLocaleString()}
                </span>
                <span className="text-zinc-800 font-semibold">KWD</span>
              </div>
            </div>
            <img src="/images/total-redemption.svg" alt="Redemption" />
          </div>
          <div className="self-stretch mt-2 pt-2 border-t border-gray-100">
            <div className="text-zinc-500 text-xs">
              {loading ? "" : "Investment fund redemptions"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCards;
